/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import Step from './Step'
import HeroWithVideo from './HeroWithVideo'
import KImage from '@/types/KImage'

export default class Homepage {
  private json: any
  public readonly disclaimer: string
  public readonly heading: string
  public readonly instructions: string
  public readonly steps: Step[]
  public readonly video: HeroWithVideo
  public readonly alternativeImage?: KImage

  constructor (json: any) {
    this.json = json
    this.disclaimer = json.disclaimer
    this.heading = json.heading
    this.instructions = json.instructions
    this.steps = json.steps.map(Step.of)
    let alternativeImage
    if (json.alternate_image?.url) {
      alternativeImage = new KImage(
        json.alternate_image.url,
        json.alternate_image.content_type,
        json.alt_text_image
      )
    }
    this.video = json.video.length ? HeroWithVideo.of(json.video[0], alternativeImage) : HeroWithVideo.empty()
  }

  static of (json: any): Homepage {
    return new Homepage(json)
  }

  static empty (): Homepage {
    return new Homepage({
      disclaimer: '',
      heading: '',
      instruction: '',
      steps: [],
      video: []
    })
  }
}
